import { getCalculatorProductsPrice } from '~/services/calculator.service'
import type {
    ICalculatorRawSetting,
    ICalculatorSelectedValues,
    ICalculatorSetting,
    ICalculatorSettingUpdaters,
    IFieldTitlesBySlug,
} from '~/types/calculator.types'

export const audioguideCalculatorRawSetting: ICalculatorRawSetting = {
    fields: [
        {
            title: 'Аудиогиды, шт.',
            slug: 'audioguide_count',
            max_count: 1000,
            default_disabled: false,
            default_hidden: false,
        },
        {
            title: 'Количество маячков-излучателей (обычно равно количеству экспонатов)',
            slug: 'trackers_count',
            max_count: 1000,
            default_disabled: false,
            default_hidden: true,
        },
        {
            title: 'Количество зарядок',
            slug: 'storage_bag_count',
            max_count: 100,
            default_disabled: false,
            default_hidden: false,
        },
    ],
    default_values: {
        type: 'A1',
        audioguide_count: 10,
        headphones: 'p303',
        storage_bag: 'di10andc1',
        storage_bag_count: 1,
        trackers_count: 0,
    },
    fields_modal: [
        {
            type: 'select',
            slug: 'type',
            prevent_hidden: false,
        },
        {
            type: 'counter',
            slug: 'audioguide_count',
            prevent_hidden: false,
        },
        {
            type: 'select',
            slug: 'headphones',
            prevent_hidden: false,
        },
        {
            type: 'select',
            slug: 'storage_bag',
            prevent_hidden: false,
        },
        {
            type: 'counter',
            slug: 'storage_bag_count',
            prevent_hidden: false,
        },
        {
            type: 'counter',
            slug: 'trackers_count',
            prevent_hidden: false,
        },
    ],
    fields_order: [
        'type',
        'audioguide_count',
        'headphones',
        'storage_bag',
        'storage_bag_count',
        'trackers_count',
    ],
    images: [
        {
            counter_from: 'audioguide_count',
            success_icon: false,
            hide_count: false,
            align: 'col',
            size: 'big',
            images: [
                {
                    image: '/assets/images/products/audioguide/jpg-png/a1-base.png',
                    image_webp:
                        '/assets/images/products/audioguide/webp/a1-base.webp',
                    values: {
                        type: 'A1',
                        headphones: 'p303',
                    },
                },
                {
                    image: '/assets/images/products/audioguide/jpg-png/a1-comfort.png',
                    image_webp:
                        '/assets/images/products/audioguide/webp/a1-comfort.webp',
                    values: {
                        type: 'A1',
                        headphones: 'p101',
                    },
                },
                {
                    image: '/assets/images/products/audioguide/jpg-png/a1-disposable.png',
                    image_webp:
                        '/assets/images/products/audioguide/webp/a1-disposable.webp',
                    values: {
                        type: 'A1',
                        headphones: 'de300',
                    },
                },
                {
                    image: '/assets/images/products/audioguide/jpg-png/a1-dark.png',
                    image_webp:
                        '/assets/images/products/audioguide/webp/a1-dark.webp',
                    values: {
                        type: 'A1',
                        headphones: 'without-headphones',
                    },
                },
                {
                    image: '/assets/images/products/audioguide/jpg-png/a1-stereo.png',
                    image_webp:
                        '/assets/images/products/audioguide/webp/a1-stereo.webp',
                    values: {
                        type: 'A1',
                        headphones: 'p202',
                    },
                },
                {
                    image: '/assets/images/products/audioguide/jpg-png/a1-pro-base.png',
                    image_webp:
                        '/assets/images/products/audioguide/webp/a1-pro-base.webp',
                    values: {
                        type: 'A1pro',
                        headphones: 'p303',
                    },
                },
                {
                    image: '/assets/images/products/audioguide/jpg-png/a1-pro-comfort.png',
                    image_webp:
                        '/assets/images/products/audioguide/webp/a1-pro-comfort.webp',
                    values: {
                        type: 'A1pro',
                        headphones: 'p101',
                    },
                },
                {
                    image: '/assets/images/products/audioguide/jpg-png/a1-pro-disposable.png',
                    image_webp:
                        '/assets/images/products/audioguide/webp/a1-pro-disposable.webp',
                    values: {
                        type: 'A1pro',
                        headphones: 'de300',
                    },
                },
                {
                    image: '/assets/images/products/audioguide/jpg-png/a1-pro.png',
                    image_webp:
                        '/assets/images/products/audioguide/webp/a1-pro.webp',
                    values: {
                        type: 'A1pro',
                        headphones: 'without-headphones',
                    },
                },
                {
                    image: '/assets/images/products/audioguide/jpg-png/a1-pro-stereo.png',
                    image_webp:
                        '/assets/images/products/audioguide/webp/a1-pro-stereo.webp',
                    values: {
                        type: 'A1pro',
                        headphones: 'p202',
                    },
                },
                {
                    image: '/assets/images/products/audioguide/jpg-png/a5-base.png',
                    image_webp:
                        '/assets/images/products/audioguide/webp/a5-base.webp',
                    values: {
                        type: 'A5',
                        headphones: 'p303',
                    },
                },
                {
                    image: '/assets/images/products/audioguide/jpg-png/a5-comfort.png',
                    image_webp:
                        '/assets/images/products/audioguide/webp/a5-comfort.webp',
                    values: {
                        type: 'A5',
                        headphones: 'p101',
                    },
                },
                {
                    image: '/assets/images/products/audioguide/jpg-png/a5-disposable.png',
                    image_webp:
                        '/assets/images/products/audioguide/webp/a5-disposable.webp',
                    values: {
                        type: 'A5',
                        headphones: 'de300',
                    },
                },
                {
                    image: '/assets/images/products/audioguide/jpg-png/a5.png',
                    image_webp:
                        '/assets/images/products/audioguide/webp/a5.webp',
                    values: {
                        type: 'A5',
                        headphones: 'without-headphones',
                    },
                },
                {
                    image: '/assets/images/products/audioguide/jpg-png/a5-stereo.png',
                    image_webp:
                        '/assets/images/products/audioguide/webp/a5-stereo.webp',
                    values: {
                        type: 'A5',
                        headphones: 'p202',
                    },
                },
            ],
        },
        {
            counter_from: 'storage_bag_count',
            success_icon: false,
            hide_count: false,
            align: 'col',
            size: 'big',
            images: [
                {
                    image: '/assets/images/products/kit/jpg-png/audioguide-charging-with-case.png',
                    image_webp:
                        '/assets/images/products/kit/webp/audioguide-charging-with-case.webp',
                    values: {
                        storage_bag: 'di10andc1',
                    },
                },
                {
                    image: '/assets/images/products/charging/jpg-png/audioguide-charging.png',
                    image_webp:
                        '/assets/images/products/charging/webp/audioguide-charging.webp',
                    values: {
                        storage_bag: 'di10',
                    },
                },
            ],
        },
    ],
    price_modificators: {
        headphones: {
            de300: 1000,
        },
    },
    prices: {},
}

export const audioguideFieldTitles: IFieldTitlesBySlug = {
    type: 'Тип аудиогидов',
    headphones: 'Наушники для&nbsp;аудиогидов',
    storage_bag: 'Хранение (зарядка)',
}

export const audioguideUpdaters: ICalculatorSettingUpdaters = {
    type: updateAudioguideTrackersCount,
    storage_bag: updateAudioguideStorageBagCount,
    audioguide_count: updateAudioguideStorageBagCount,
}

function updateAudioguideStorageBagCount(
    selectedValues: ICalculatorSelectedValues
): [string, string | number, boolean, boolean][] {
    if (
        selectedValues.storage_bag === 'no-charger' ||
        typeof selectedValues['audioguide_count'] !== 'number'
    ) {
        return [['storage_bag_count', 0, false, false]]
    }

    const value = Math.round(selectedValues.audioguide_count / 10)

    return [['storage_bag_count', value > 0 ? value : 1, false, false]]
}

function updateAudioguideTrackersCount(
    selectedValues: ICalculatorSelectedValues
): [string, string | number, boolean, boolean][] {
    if (selectedValues.type !== 'A1pro') {
        return [['trackers_count', 0, false, true]]
    }

    return [['trackers_count', 1, false, false]]
}

export function audioguideGetPrice(
    calculator: ICalculatorSetting,
    selectedValues: ICalculatorSelectedValues
): string {
    const productPrices: { [key: string]: number } = getCalculatorProductsPrice(
        calculator,
        selectedValues
    )

    const audioguidePrice: number =
        Number(selectedValues.audioguide_count) * productPrices['type']

    const headphonesPrice: number =
        (productPrices['headphones'] || 0) *
        (calculator.price_modificators['headphones']?.[
            selectedValues['headphones']
        ]
            ? 1
            : Number(selectedValues.audioguide_count))

    const trackersPrice: number =
        Number(selectedValues.trackers_count) * productPrices['m1']

    const storageBagPrice: number =
        productPrices['storage_bag'] * Number(selectedValues.storage_bag_count)

    const price: number =
        audioguidePrice + headphonesPrice + trackersPrice + storageBagPrice

    return formatPrice(price)
}
